"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_List = exports.ListModeKind = exports.ListStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var RTTI_List_Entry_1 = require("./RTTI_List_Entry");
var ListStatusKind;
(function (ListStatusKind) {
    ListStatusKind["_current"] = "current";
    ListStatusKind["_retired"] = "retired";
    ListStatusKind["_enteredInError"] = "entered-in-error";
})(ListStatusKind = exports.ListStatusKind || (exports.ListStatusKind = {}));
var ListModeKind;
(function (ListModeKind) {
    ListModeKind["_working"] = "working";
    ListModeKind["_snapshot"] = "snapshot";
    ListModeKind["_changes"] = "changes";
})(ListModeKind = exports.ListModeKind || (exports.ListModeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_List = t.recursion('IList', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('List')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            status: (0, EnumType_1.createEnumType)(ListStatusKind, 'ListStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            mode: (0, EnumType_1.createEnumType)(ListModeKind, 'ListModeKind'),
            _mode: RTTI_Element_1.RTTI_Element,
            title: t.string,
            _title: RTTI_Element_1.RTTI_Element,
            code: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            subject: RTTI_Reference_1.RTTI_Reference,
            encounter: RTTI_Reference_1.RTTI_Reference,
            date: RTTI_dateTime_1.RTTI_dateTime,
            _date: RTTI_Element_1.RTTI_Element,
            source: RTTI_Reference_1.RTTI_Reference,
            orderedBy: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            note: t.array(RTTI_Annotation_1.RTTI_Annotation),
            entry: t.array(RTTI_List_Entry_1.RTTI_List_Entry),
            emptyReason: RTTI_CodeableConcept_1.RTTI_CodeableConcept
        })
    ]);
});
//# sourceMappingURL=RTTI_List.js.map